export class TourThematic {
  id: number;
  tourId: number;
  themeId: number;
}
